module.exports = __webpack_public_path__ + "img/background_12165.d9fc3e87.png";